import { Component, Input, EventEmitter, Output } from "@angular/core";
import { NotificationHubService, MessageTemplateDefinition, DeliveryProvider, WorkerRecipientIdentity, SendSMSNotificationData, ApplicationIdentity, SendNotificationRequest, NotificationStatus } from "../../../common/notificationHub/notificationHub.service";
import "../../../util/string";

export enum SendSMSResult {
    Succedded,
    Failed,
    Cancelled
}

export class SendSMSData {
    public name: string;
    public phone: string;
    public email: string;
    public message: string;
    public sendSMSCallback: (success: SendSMSResult) => void;

    constructor(name: string, phone: string, email: string, message: string, sendSMSCallback: (success: SendSMSResult) => void = null) {
        this.name = name;
        this.phone = phone;
        this.email = email;
        this.message = message;
        this.sendSMSCallback = sendSMSCallback;
    }
}

@Component({
    selector: 'send-sms',
    templateUrl: './sendSMS.component.html',
    styleUrls: ['./sendSMS.component.css'],
    standalone: false
})
export class SendSMSComponent {
    @Input() public data: SendSMSData;
    @Output() public onMessageSent: EventEmitter<SendSMSResult> = new EventEmitter<SendSMSResult>();
    public isBusy: boolean = false;

    constructor(private notificationHubService: NotificationHubService) {
    }

    public async sendMessage(event: Event): Promise<void> {
        if (event) event.stopPropagation();

        try {
            this.isBusy = true;

            let request = new SendNotificationRequest();
            request.applicationIdentity = new ApplicationIdentity();
            request.applicationIdentity.business = "NotificationHubTestBusiness";
            request.applicationIdentity.process = "NotificationHubTestProcess";
            request.applicationIdentity.event = "NotificationHubTestEvent";
            let sms = new SendSMSNotificationData();
            request.notifications = new Array(1);
            request.notifications[0] = sms;
            sms.deliveryProvider = DeliveryProvider.ConfigureMovistarSMSProvider();
            sms.recipient = this.data.phone;
            sms.recipientIdentity = new WorkerRecipientIdentity(this.data.email);
            sms.template = new MessageTemplateDefinition(this.data.message);
            let response = await this.notificationHubService.sendNotification(request);
            if (response.notifications[0].status == NotificationStatus.Rejected) {
                throw response.notifications[0].rejectionReason;
            }

            this.isBusy = false;

            this.onMessageSent.emit(SendSMSResult.Succedded);
            if (this.data && this.data.sendSMSCallback) {
                this.data.sendSMSCallback(SendSMSResult.Succedded);
            }
        } catch {
            this.isBusy = false;
            this.onMessageSent.emit(SendSMSResult.Failed);
            if (this.data && this.data.sendSMSCallback) {
                this.data.sendSMSCallback(SendSMSResult.Failed);
            }
        }
    }

    public cancel(event: Event): void {
        if (event) event.stopPropagation();

        this.onMessageSent.emit(SendSMSResult.Cancelled);
        if (this.data && this.data.sendSMSCallback) {
            this.data.sendSMSCallback(SendSMSResult.Cancelled);
        }
    }
}